"use client"

import {createContext, useContext} from "react";

// Site-wide default props for core form fields (text_input, text_area, select_box, radio_button, checkbox,
// switch_button, toggle_button, file_input, select_box_input). Added for isource and tsco-glass, which forked these components only
// to change classes and the error `t`; the class strings stay in the site's file, where its Tailwind sees them.
export const FormFieldsContext = createContext(null);

export const FormFieldsProvider = ({value, children}) => (
	<FormFieldsContext.Provider value={value || null}>
		{children}
	</FormFieldsContext.Provider>
);

// The field's props on top of the provider's defaults for `name`. An `undefined` prop keeps the default;
// `classNames` are merged slot by slot. Without a provider the props come back unchanged.
export const useFormFieldProps = (name, props) => {
	const preset = useContext(FormFieldsContext)?.[name];
	if (!preset) return props;
	const merged = {...preset};
	for (const key in props) {
		if (props[key] !== undefined) merged[key] = props[key];
	}
	if (preset.classNames && props.classNames) {
		merged.classNames = {...preset.classNames, ...props.classNames};
	}
	return merged;
};
